import { render, staticRenderFns } from "./TranslationForm.vue?vue&type=template&id=2ae16bf6&"
import script from "./TranslationForm.vue?vue&type=script&lang=js&"
export * from "./TranslationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports